module.exports = __webpack_public_path__ + "media/images/photo/plans/places/yoyogi_park-690dd71b9e50775d77d8478b3a93c304.png";